import {
  $applyNodeReplacement,
  type DOMExportOutput,
  type EditorConfig,
  type LexicalNode,
  type NodeKey,
  type SerializedTextNode,
  TextNode
} from "lexical"

type Type = "closed-tag"

export type SerializedClosedTagNode = SerializedTextNode & { type: Type }

export class ClosedTagNode extends TextNode {
  __className = "editor-dynamic-tag editor-dynamic-tag_closed"

  static getType(): Type {
    return "closed-tag"
  }

  static clone(node: ClosedTagNode): ClosedTagNode {
    return new ClosedTagNode(node.__text, node.__key)
  }

  constructor(text: string, key?: NodeKey) {
    super(text, key)
    this.__mode = 1
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config)

    dom.className = this.__className

    return dom
  }

  updateDOM(
    _prevNode: TextNode,
    _dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    return true
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement("span")

    element.textContent = this.__text

    return { element }
  }

  static importJSON(serializedNode: SerializedClosedTagNode): ClosedTagNode {
    const node = $createClosedTagNode(serializedNode.text)

    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setStyle(serializedNode.style)

    return node
  }

  exportJSON(): SerializedClosedTagNode {
    return {
      ...super.exportJSON(),
      type: "closed-tag"
    }
  }

  canInsertTextBefore(): boolean {
    return false
  }

  canInsertTextAfter(): boolean {
    return true
  }

  isTextEntity(): boolean {
    return true
  }
}

export function $createClosedTagNode(text: string): ClosedTagNode {
  return $applyNodeReplacement(new ClosedTagNode(text))
}

export function $isClosedTagNode(
  node: LexicalNode | null | undefined
): node is ClosedTagNode {
  return node instanceof ClosedTagNode
}
